import { JsonRpcProvider } from "ethers";

export const CONTROLLER_ADDRESS = import.meta.env
  .VITE_CONTROLLER_ADDRESS as `0x${string}`;

// ✅ Provider principal (Northflank RPC)
export const RPC_URL = import.meta.env.VITE_RPC_URL as string;
export const staticProvider = new JsonRpcProvider(RPC_URL);

// ✅ Tokens UC Waves
export const TOKENS = {
  USDC: import.meta.env.VITE_USDC_ADDRESS as `0x${string}`,
  NAU: import.meta.env.VITE_NAU as `0x${string}`,
  NAUY: import.meta.env.VITE_NAUY as `0x${string}`,
  NAUN: import.meta.env.VITE_NAUN as `0x${string}`,
};

export const WC_PROJECT_ID = import.meta.env.VITE_WC_PROJECT_ID as string;

// ✅ Network config
export const chainId = import.meta.env.VITE_EXPECTED_CHAIN_ID as string;

export const BASE_URL =
  "https://site--ucwaves-p1-backend-deployment--r9qw5p2frw6c.code.run";
